import { render, staticRenderFns } from "./GroupHomeOption.vue?vue&type=template&id=beb24a02&scoped=true"
import script from "./GroupHomeOption.vue?vue&type=script&lang=js"
export * from "./GroupHomeOption.vue?vue&type=script&lang=js"
import style0 from "./GroupHomeOption.vue?vue&type=style&index=0&id=beb24a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb24a02",
  null
  
)

export default component.exports